/**
 * <lv-countdown> — Counts down to 23:59:59 local time today.
 * Fills [data-h], [data-m] and [data-s] children with zero-padded values.
 */
class LvCountdown extends HTMLElement {
  connectedCallback() {
    const end = new Date();
    end.setHours(23, 59, 59, 0);
    const pad = (n) => String(n).padStart(2, '0');
    const h = this.querySelector('[data-h]');
    const m = this.querySelector('[data-m]');
    const s = this.querySelector('[data-s]');
    const tick = () => {
      const left = Math.max(0, Math.floor((end.getTime() - Date.now()) / 1000));
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
      if (s) s.textContent = pad(left % 60);
    };
    tick();
    this.timer = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
}

if (!customElements.get('lv-countdown')) customElements.define('lv-countdown', LvCountdown);
